import React, { useEffect } from "react";
import "./App.css";
import "./styles/Blog.css";
import { BLOG_POSTS, postPath } from "./BlogPosts";

/* ------------------------------------------------------------------
   Blog page: lists every post in blogPosts.js, newest first.
   Route: /blog
------------------------------------------------------------------- */
const SITE = "https://atappliancemaster.com";
const PAGE_URL = SITE + "/blog";
const PAGE_TITLE = "Appliance Repair Tips & Advice | AT Appliance Repair Blog";
const PAGE_DESCRIPTION =
  "Appliance repair advice from our technicians in Plainfield, Naperville & nearby: repair or replace, pricing, payments and luxury appliance care.";

const PHONE_DISPLAY = "(331) 600-4935";
const PHONE_LINK = "tel:+13316004935";

export default function BlogIndex() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const set = (selector, tag, attr, key, valueAttr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement(tag);
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute(valueAttr, value);
    };
    set('meta[name="description"]', "meta", "name", "description", "content", PAGE_DESCRIPTION);
    set('link[rel="canonical"]', "link", "rel", "canonical", "href", PAGE_URL);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "AT Appliance Repair Blog",
    url: PAGE_URL,
    blogPost: BLOG_POSTS.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      url: SITE + postPath(p.slug),
      datePublished: p.date,
    })),
  };

  return (
    <main className="blog-post">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />

      <nav className="breadcrumb" aria-label="Breadcrumb">
        <a href="/">Home</a> / <span>Blog</span>
      </nav>

      <article className="blog-index">
        <header className="post-header">
          <p className="post-kicker">AT Appliance Repair Blog</p>
          <h1>Appliance Repair Tips &amp; Advice</h1>
          <p className="post-lead">
            Straight answers from the technicians who fix appliances in Plainfield, Naperville, Aurora, Joliet and
            nearby towns every day.
          </p>
        </header>

        <div className="post-list">
          {BLOG_POSTS.map((p) => (
            <a className="post-card" href={postPath(p.slug)} key={p.slug}>
              <span className="post-card-meta">
                {p.category} · <time dateTime={p.date}>{p.dateLabel}</time> · {p.readTime}
              </span>
              <span className="post-card-title">{p.title}</span>
              <span className="post-card-excerpt">{p.excerpt}</span>
              <span className="post-card-more">Read the article →</span>
            </a>
          ))}
        </div>

        <aside className="post-cta">
          <h2>Need an appliance repaired?</h2>
          <p>Same-day service in most cases, 7 days a week from 8 a.m. to 9 p.m.</p>
          <p>
            <a className="schedule-button" href={PHONE_LINK}>Call {PHONE_DISPLAY}</a>{" "}
            <a className="schedule-button cta-secondary" href="/contact">Schedule Service</a>
          </p>
        </aside>
      </article>

      <a className="mobile-call" href={PHONE_LINK}>Call {PHONE_DISPLAY}</a>
    </main>
  );
}